import InboxRule from 'owa-service/lib/contract/InboxRule';
import InboxRuleInformation from './store/schema/InboxRuleInformation';
import mapInboxRuleToInboxRuleInformation from './utils/mapInboxRuleToInboxRuleInformation';
import InboxRuleActionSource from './store/schema/InboxRuleActionSource';
import InboxRuleRowType from './store/schema/InboxRuleRowType';

export default {
    enableDisableInboxRuleDatapoint: {
        name: 'TnS_EnableDisableInboxRule',
        customData: (
            inboxRuleId: string,
            shouldBeEnabled: boolean,
            force: boolean,
            alwaysDeleteOutlookRulesBlob: boolean
        ) => [inboxRuleId, shouldBeEnabled, force, alwaysDeleteOutlookRulesBlob],
    },
    generateInboxRulesDiagnosticReportDatapoint: { name: 'TnS_GenerateInboxRulesDiagnosticReport' },
    getInboxRulesDatapoint: { name: 'TnS_GetInboxRules' },
    createNewInboxRuleDatapoint: {
        name: 'TnS_NewInboxRule',
        customData: (
            inboxRule: InboxRule,
            actionSource: InboxRuleActionSource,
            onSuccess: () => {},
            onFailure: () => {}
        ) => {
            const result = mapInboxRuleToInboxRuleInformation(inboxRule);
            result.ActionSource = actionSource;
            return result;
        },
    },
    setInboxRuleDatapoint: {
        name: 'TnS_SetInboxRule',
        customData: (
            inboxRule: InboxRule,
            force: boolean,
            alwaysDeleteOutlookRulesBlob: boolean
        ) => {
            const result = mapInboxRuleToInboxRuleInformation(inboxRule);
            result.Force = force;
            result.AlwaysDeleteOutlookRulesBlob = alwaysDeleteOutlookRulesBlob;
            return result;
        },
    },
    removeInboxRuleDatapoint: {
        name: 'TnS_RemoveInboxRule',
        customData: (
            inboxRule: InboxRuleRowType,
            force: boolean,
            alwaysDeleteOutlookRulesBlob: boolean
        ) => {
            const result = mapInboxRuleToInboxRuleInformation(inboxRule);
            result.Force = force;
            result.AlwaysDeleteOutlookRulesBlob = alwaysDeleteOutlookRulesBlob;
            return result;
        },
    },
    setInboxRulesDatapoint: { name: 'TnS_SetInboxRules' },
    addPhraseToClauseDatapoint: {
        name: 'TnS_AddPhraseToClause',
        customData: (
            clauseId: string,
            phraseToAdd: string,
            actionSource: InboxRuleActionSource
        ) => [phraseToAdd.indexOf(' ') !== -1, actionSource],
    },
    inboxRuleActionFailDatapoint: {
        name: 'TnS_InboxRuleActionFail',
        customData: (inboxRuleInformation: InboxRuleInformation) => {
            return inboxRuleInformation;
        },
    },
};
